"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFederatedSearchIntegrationPanel;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _PanelItems = require("../PanelItems");

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _SalesforceLanguages = _interopRequireDefault(require("../../assets/SalesforceLanguages"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _FederatedSearchSyncStatus = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/searchSyncStatus/FederatedSearchSyncStatus"));

var _constants = require("@insided/shared/constants");

var _utils = require("../../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var channelList = [{
  title: 'Public knowledge base',
  value: 'Pkb'
}, {
  title: 'Customer portal',
  value: 'Csp'
}, {
  title: 'Partner portal',
  value: 'Prm'
}, {
  title: 'Internal knowledge application',
  value: 'App'
}];

function getFederatedSearchIntegrationPanel(props) {
  var isInstalled = props.isInstalled,
      isSettingEnabled = props.isSettingEnabled,
      onSave = props.onSave,
      onCancel = props.onCancel,
      onSettingChanged = props.onSettingChanged,
      showActionButtons = props.showActionButtons,
      hasUnsavedChanges = props.hasUnsavedChanges,
      onClickPanelCallback = props.onClickPanelCallback,
      storedState = props.storedState,
      errorFields = props.errorFields,
      federatedSearchLocale = props.federatedSearchLocale,
      _onFederatedSearchLocaleClicked = props.onFederatedSearchLocaleClicked,
      onFederatedSearchDomainClicked = props.onFederatedSearchDomainClicked,
      federatedSearchInitialSyncCompleted = props.federatedSearchInitialSyncCompleted,
      isCustomDomainEnabled = props.isCustomDomainEnabled,
      customDomain = props.customDomain,
      channel = props.channel,
      toggleCustomDomainField = props.toggleCustomDomainField,
      setCustomDomainField = props.setCustomDomainField,
      setChannelField = props.setChannelField,
      isLoading = props.isLoading;
  return (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Salesforce federated search',
    isInstalled: isInstalled,
    isSettingEnabled: isSettingEnabled,
    imageFromName: 'salesforce-s',
    imageToName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    onSettingChanged: onSettingChanged,
    onSave: onSave,
    onCancel: onCancel,
    showActionButtons: showActionButtons,
    toggleLabel: 'Enable Salesforce federated search',
    communityArticleLink: 'https://community.insided.com/integrations-124/salesforce-federated-search-a-brief-tutorial-3300',
    description: "Empower end users to search for Salesforce knowledge base content through ".concat(_constants.PLATFORM_BRAND_NAME, "."),
    storedIsSettingEnabled: storedState.isFederatedSearchEnabled,
    hasUnsavedChanges: hasUnsavedChanges,
    customClass: 'qa-salesforce-federated-search',
    onClickPanel: onClickPanelCallback,
    additionalHelpText: (0, _preact.h)(AdditionalHelpText, null),
    additionalInputFields: (0, _preact.h)(FederatedSearchInputField, {
      errorFields: errorFields,
      onFederatedSearchLocaleClicked: function onFederatedSearchLocaleClicked(locale) {
        return _onFederatedSearchLocaleClicked(locale);
      },
      onFederatedSearchDomainClicked: onFederatedSearchDomainClicked,
      federatedSearchLocale: federatedSearchLocale,
      isCustomDomainEnabled: isCustomDomainEnabled,
      customDomain: customDomain,
      channel: channel,
      toggleCustomDomainField: toggleCustomDomainField,
      setCustomDomainField: setCustomDomainField,
      setChannelField: setChannelField
    }),
    integrationStatus: (0, _preact.h)(_FederatedSearchSyncStatus.default, {
      isFederatedSearchActive: storedState.isFederatedSearchEnabled,
      federatedSearchInitialSyncCompleted: federatedSearchInitialSyncCompleted,
      syncUrl: "/integration/salesforce/sync",
      syncedDataType: "Salesforce articles"
    }),
    isLoading: isLoading
  });
}

var AdditionalHelpText = function AdditionalHelpText() {
  var communityUrl = (0, _globals.default)('communityUrl');
  var safeUrl = (0, _utils.sanitizeUrl)(communityUrl);
  return (0, _preact.h)("span", null, "View Salesforce Guide Help Center content in the", ' ', (0, _preact.h)("a", {
    className: "overview-page-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(safeUrl.concat('/search')),
    rel: "noreferrer",
    target: "_blank"
  }, "search result"), ' ', "on the community destination.", ' ');
};

var FederatedSearchInputField = function FederatedSearchInputField(_ref) {
  var _channelList$find;

  var federatedSearchLocale = _ref.federatedSearchLocale,
      onFederatedSearchLocaleClicked = _ref.onFederatedSearchLocaleClicked,
      errorFields = _ref.errorFields,
      onFederatedSearchDomainClicked = _ref.onFederatedSearchDomainClicked,
      isCustomDomainEnabled = _ref.isCustomDomainEnabled,
      customDomain = _ref.customDomain,
      toggleCustomDomainField = _ref.toggleCustomDomainField,
      setCustomDomainField = _ref.setCustomDomainField,
      setChannelField = _ref.setChannelField,
      channel = _ref.channel;
  var showLanguageError = (0, _PanelItems.getErrorMessage)('federatedSearchLanguage', errorFields) !== '';
  var domainError = (0, _PanelItems.getErrorMessage)('knowledgeBaseDomain', errorFields);
  var selectedChannelTitle = (_channelList$find = channelList.find(function (c) {
    return c.value === channel;
  })) === null || _channelList$find === void 0 ? void 0 : _channelList$find.title;
  return (0, _preact.h)("div", {
    className: "salesforce-federated-search-inputs"
  }, (0, _preact.h)("div", {
    className: "panel-input-dropdown-container integrations-language-selector"
  }, (0, _preact.h)("div", {
    className: "language-dropdown-category-label"
  }, " Filter by language"), (0, _preact.h)("div", {
    className: "language-dropdown-category-meta"
  }, ' ', "Select the language that you want to show in federated search."), (0, _preact.h)("div", {
    className: "form-group"
  }, (0, _preact.h)(_DropdownControl.default, {
    closeOnDropdownClick: true,
    className: "salesforce-language-selector",
    triggerClass: "salesforce-language-selector-trigger",
    align: "adjust",
    searchPlaceholderText: "Search for language",
    trigger: function trigger(isTriggerOpen) {
      return (0, _preact.h)(_Button.default, {
        title: federatedSearchLocale ? "".concat(federatedSearchLocale === null || federatedSearchLocale === void 0 ? void 0 : federatedSearchLocale.title, ": ").concat(federatedSearchLocale === null || federatedSearchLocale === void 0 ? void 0 : federatedSearchLocale.value) : 'Select a language',
        className: "integrations-salesforce_language-selector qa-salesforce-language-selector \n                              ".concat(isTriggerOpen ? 'language-selector-is-open' : 'language-selector-is-closed', " \n                              ").concat(showLanguageError ? 'validation-error' : '', " "),
        icon: "chevronDown"
      });
    },
    items: _SalesforceLanguages.default.map(function (salesforceLanguage) {
      return {
        title: "".concat(salesforceLanguage.title, ": ").concat(salesforceLanguage.value),
        value: salesforceLanguage.value,
        onClick: function onClick() {
          return onFederatedSearchLocaleClicked(salesforceLanguage);
        }
      };
    }),
    hasSearch: true,
    newStyle: true,
    searchIconHeight: 16,
    searchIconWidth: 16
  }), showLanguageError && (0, _preact.h)(_IntegrationPanelItems.InputValidationError, {
    message: "Please select a language."
  }))), (0, _preact.h)("div", {
    className: "panel-input-dropdown-container integrations-language-selector"
  }, (0, _preact.h)("div", {
    className: "language-dropdown-category-label"
  }, "Channel"), (0, _preact.h)("div", {
    className: "form-group"
  }, (0, _preact.h)(_DropdownControl.default, {
    closeOnDropdownClick: true,
    className: "salesforce-language-selector",
    triggerClass: "salesforce-language-selector-trigger",
    align: "adjust",
    trigger: function trigger(isTriggerOpen) {
      return (0, _preact.h)(_Button.default, {
        title: selectedChannelTitle,
        className: "integrations-salesforce_language-selector qa-salesforce-language-selector ".concat(isTriggerOpen ? 'language-selector-is-open' : 'language-selector-is-closed'),
        icon: "chevronDown"
      });
    },
    items: channelList.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        onClick: function onClick() {
          return setChannelField(item.value);
        }
      });
    }),
    newStyle: true,
    searchIconHeight: 16,
    searchIconWidth: 16
  }))), (0, _preact.h)("div", {
    className: "knowledge-base-domain"
  }, (0, _preact.h)(_Checkbox.default, {
    label: "Use a custom knowledge base domain. This overrides the default host.",
    onUpdate: toggleCustomDomainField,
    qaClasses: "qa-open",
    checked: !!isCustomDomainEnabled
  }), isCustomDomainEnabled && (0, _preact.h)("div", {
    className: "panel-input-dropdown-container"
  }, (0, _preact.h)("div", {
    className: "panel-form-input"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "apiKey",
    title: "Custom domain",
    value: customDomain,
    qaClasses: "qa-sf-custom-domain",
    onClick: function onClick() {
      return onFederatedSearchDomainClicked(customDomain);
    },
    onChangeCallback: function onChangeCallback(e) {
      return setCustomDomainField(e.target.value);
    }
  }), domainError !== '' && (0, _preact.h)(_IntegrationPanelItems.InputValidationError, {
    message: domainError
  })))));
};